export const BASE_MAP = {
  name: "BASE_MAP",
  url: "https://gis.toris.gov.spb.ru/arcgis1031/rest/services/BASE_MAP/MapServer/WMTS/1.0.0/WMTSCapabilities.xml",
};
export const BM_MSK_GRAY = {
  name: "BM_MSK_GRAY",
  url: "https://gis.toris.gov.spb.ru/arcgis1031/rest/services/BM_MSK_GRAY/MapServer/WMTS/1.0.0/WMTSCapabilities.xml",
};
export const ORTOPHOTO_2016 = {
  name: "ORTOPHOTO_2016",
  url: "https://gis.toris.gov.spb.ru/arcgis1031/rest/services/ORTOPHOTO_2016/MapServer/WMTS/1.0.0/WMTSCapabilities.xml",
};
